import StatusTag from './StatusTag';

export default StatusTag;
